import Airway from "./Airway";
import Allergies from "./Allergies";
import Brain from "./Brain";
import bypass from "./bypass";
import CareNote from "./CareNote";
import ChartSummary from "./ChartSummary";
import ChestTube from "./ChestTube";
import Creatinine from "./Creatinine";
import DeteriorationIndex from "./DeteriorationIndex";
import dnc from "./dnc";
import Ebl from "./Ebl";
import GenericRiskAndGraph from "./GenericRiskAndGraph";
import Heart from "./Heart";
import Hem from "./Hem";
import Icp from "./Icp";
import InfectiousDiseases from "./InfectiousDiseases";
import Infusions from "./Infusions";
import ioBalance from "./ioBalance";
import LegendDescription from "./LegendDescription";
import Liver from "./Liver";
import Lungs from "./Lungs";
import Notes from "./Notes";
import O2 from "./O2";
import PainScore from "./PainScore";
import PatientHandoff from "./PatientHandoff";
import Pump from "./Pump";
import Qsofa from "./Qsofa";
import review from "./review";
import Settings from "./Settings";
import Sirs from "./Sirs";
import Sofa from "./Sofa";
import Spine from "./Spine";
import Temperature from "./Temperature";
import tower from "./tower";
import PostOpReview from "./PostOpReview";
import Ulcer from "./Ulcer";
import Urine from "./Urine";
import Uterus from "./Uterus";
import Waveforms from "./Waveforms";
import WeightAndIoBalance from "./WeightAndIoBalance";

export default {
  Airway,
  Allergies,
  Brain,
  bypass,
  CareNote,
  ChartSummary,
  ChestTube,
  Notes,
  DeteriorationIndex,
  Ebl,
  GenericRiskAndGraph,
  Heart,
  Hem,
  Icp,
  InfectiousDiseases,
  Infusions,
  ioBalance,
  Creatinine,
  Urine,
  LegendDescription,
  Liver,
  Lungs,
  O2,
  PainScore,
  PatientHandoff,
  PostOpReview,
  Pump,
  Qsofa,
  review,
  dnc,
  Settings,
  Sirs,
  Sofa,
  Spine,
  Temperature,
  tower,
  Ulcer,
  Uterus,
  Waveforms,
  WeightAndIoBalance
};
